// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.holidays-container {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.holidays-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.holidays-title-section h1 {
  margin: 0 0 0.5rem 0;
  font-size: 2rem;
  color: #1a1a1a;
}

.holidays-subtitle {
  margin: 0;
  color: #666;
  font-size: 0.95rem;
  max-width: 600px;
}

.holidays-controls {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.year-selector {
  padding: 0.6rem 1.2rem;
  font-size: 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
}

.year-selector:hover {
  border-color: #4a90e2;
}

.year-selector:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
}

.loading-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  color: #666;
}

.spinner {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #4a90e2;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-message {
  background: #fee;
  border: 1px solid #fcc;
  color: #c33;
  padding: 1rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.error-icon {
  font-size: 1.5rem;
}

.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  color: #999;
}

.empty-icon {
  font-size: 4rem;
  display: block;
  margin-bottom: 1rem;
}

.empty-state h3 {
  margin: 0 0 0.5rem 0;
  color: #666;
}

.empty-state p {
  margin: 0;
  color: #999;
}

.holidays-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.calendar-month {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.calendar-month-header {
  margin: 0 0 1rem 0;
  font-size: 1.3rem;
  color: #1a1a1a;
  text-align: center;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 0.75rem;
}

.calendar-table {
  width: 100%;
}

.calendar-weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  margin-bottom: 2px;
}

.calendar-weekday {
  text-align: center;
  font-weight: 600;
  font-size: 0.75rem;
  color: #666;
  padding: 0.5rem 0;
  text-transform: uppercase;
}

.calendar-days {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.calendar-week {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.calendar-day {
  aspect-ratio: 1;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 0.15rem;
  background: #fafafa;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 35px;
  max-height: 50px;
  transition: all 0.2s;
  overflow: visible;
}

.calendar-day.empty {
  background: transparent;
  border: none;
}

.calendar-day.holiday {
  background: linear-gradient(135deg, #fff5f5 0%, #ffe5e5 100%);
  border: 2px solid #ff6b6b;
  box-shadow: 0 2px 4px rgba(255, 107, 107, 0.2);
}

.calendar-day.holiday:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(255, 107, 107, 0.3);
}

.day-number {
  font-size: 0.7rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.1rem;
}

.holiday-indicator {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1rem;
}

.holiday-flag {
  font-size: 1.1rem;
  line-height: 1;
}

.holiday-name-tooltip {
  position: absolute;
  bottom: -45px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.holiday-name-tooltip::before {
  content: '';
  position: absolute;
  top: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid rgba(0, 0, 0, 0.9);
}

.calendar-day.holiday:hover .holiday-name-tooltip {
  opacity: 1;
}

.month-section {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.month-header {
  margin: 0 0 1rem 0;
  font-size: 1.5rem;
  color: #1a1a1a;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 0.75rem;
}

.holidays-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
}

.holiday-card {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  background: #f9f9f9;
  border-radius: 8px;
  border: 2px solid #e8e8e8;
  transition: all 0.2s;
}

.holiday-card:hover {
  border-color: #4a90e2;
  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.1);
  transform: translateY(-2px);
}

.holiday-icon {
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background: white;
  border-radius: 8px;
  flex-shrink: 0;
}

.holiday-details {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.holiday-name {
  font-weight: 600;
  font-size: 1rem;
  color: #1a1a1a;
  margin-bottom: 0.25rem;
}

.holiday-date-info {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
}

.holiday-date {
  color: #666;
  font-size: 0.9rem;
}

.holiday-day {
  color: #4a90e2;
  font-size: 0.85rem;
  font-weight: 500;
}

.holiday-type-badge {
  display: inline-block;
  padding: 0.25rem 0.6rem;
  background: #e8f4f8;
  color: #2c7ba0;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  width: fit-content;
  margin-top: 0.25rem;
}

.holidays-info-section {
  margin-top: 2rem;
}

.info-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  border-left: 4px solid #4a90e2;
}

.info-card h3 {
  margin: 0 0 1rem 0;
  color: #1a1a1a;
  font-size: 1.1rem;
}

.info-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.info-card li {
  padding: 0.5rem 0;
  color: #555;
  line-height: 1.6;
}

.info-card li strong {
  color: #1a1a1a;
}

/* Responsive design */
@media (max-width: 768px) {
  .holidays-container {
    padding: 1rem;
  }

  .holidays-header {
    flex-direction: column;
    align-items: stretch;
  }

  .holidays-controls {
    justify-content: flex-end;
  }

  .calendar-grid {
    grid-template-columns: 1fr;
  }

  .calendar-month {
    padding: 1rem;
  }

  .calendar-month-header {
    font-size: 1.1rem;
  }

  .calendar-day {
    min-height: 32px;
    max-height: 45px;
    padding: 0.15rem;
  }

  .day-number {
    font-size: 0.65rem;
  }

  .holiday-flag {
    font-size: 1rem;
  }

  .holidays-title-section h1 {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Holidays.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".holidays-container {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.holidays-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.holidays-title-section h1 {\n  margin: 0 0 0.5rem 0;\n  font-size: 2rem;\n  color: #1a1a1a;\n}\n\n.holidays-subtitle {\n  margin: 0;\n  color: #666;\n  font-size: 0.95rem;\n  max-width: 600px;\n}\n\n.holidays-controls {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.year-selector {\n  padding: 0.6rem 1.2rem;\n  font-size: 1rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-weight: 500;\n}\n\n.year-selector:hover {\n  border-color: #4a90e2;\n}\n\n.year-selector:focus {\n  outline: none;\n  border-color: #4a90e2;\n  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);\n}\n\n.loading-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  color: #666;\n}\n\n.spinner {\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #4a90e2;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.error-message {\n  background: #fee;\n  border: 1px solid #fcc;\n  color: #c33;\n  padding: 1rem;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.error-icon {\n  font-size: 1.5rem;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 4rem 2rem;\n  color: #999;\n}\n\n.empty-icon {\n  font-size: 4rem;\n  display: block;\n  margin-bottom: 1rem;\n}\n\n.empty-state h3 {\n  margin: 0 0 0.5rem 0;\n  color: #666;\n}\n\n.empty-state p {\n  margin: 0;\n  color: #999;\n}\n\n.holidays-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 2rem;\n}\n\n.calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n}\n\n.calendar-month {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.calendar-month-header {\n  margin: 0 0 1rem 0;\n  font-size: 1.3rem;\n  color: #1a1a1a;\n  text-align: center;\n  border-bottom: 2px solid #f0f0f0;\n  padding-bottom: 0.75rem;\n}\n\n.calendar-table {\n  width: 100%;\n}\n\n.calendar-weekdays {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n  margin-bottom: 2px;\n}\n\n.calendar-weekday {\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.75rem;\n  color: #666;\n  padding: 0.5rem 0;\n  text-transform: uppercase;\n}\n\n.calendar-days {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.calendar-week {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n}\n\n.calendar-day {\n  aspect-ratio: 1;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  padding: 0.15rem;\n  background: #fafafa;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 35px;\n  max-height: 50px;\n  transition: all 0.2s;\n  overflow: visible;\n}\n\n.calendar-day.empty {\n  background: transparent;\n  border: none;\n}\n\n.calendar-day.holiday {\n  background: linear-gradient(135deg, #fff5f5 0%, #ffe5e5 100%);\n  border: 2px solid #ff6b6b;\n  box-shadow: 0 2px 4px rgba(255, 107, 107, 0.2);\n}\n\n.calendar-day.holiday:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 8px rgba(255, 107, 107, 0.3);\n}\n\n.day-number {\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 0.1rem;\n}\n\n.holiday-indicator {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.1rem;\n}\n\n.holiday-flag {\n  font-size: 1.1rem;\n  line-height: 1;\n}\n\n.holiday-name-tooltip {\n  position: absolute;\n  bottom: -45px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.9);\n  color: white;\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s;\n  z-index: 10;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.holiday-name-tooltip::before {\n  content: '';\n  position: absolute;\n  top: -4px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-bottom: 4px solid rgba(0, 0, 0, 0.9);\n}\n\n.calendar-day.holiday:hover .holiday-name-tooltip {\n  opacity: 1;\n}\n\n.month-section {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.month-header {\n  margin: 0 0 1rem 0;\n  font-size: 1.5rem;\n  color: #1a1a1a;\n  border-bottom: 2px solid #f0f0f0;\n  padding-bottom: 0.75rem;\n}\n\n.holidays-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1rem;\n}\n\n.holiday-card {\n  display: flex;\n  gap: 1rem;\n  padding: 1rem;\n  background: #f9f9f9;\n  border-radius: 8px;\n  border: 2px solid #e8e8e8;\n  transition: all 0.2s;\n}\n\n.holiday-card:hover {\n  border-color: #4a90e2;\n  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.1);\n  transform: translateY(-2px);\n}\n\n.holiday-icon {\n  font-size: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  height: 50px;\n  background: white;\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n.holiday-details {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.holiday-name {\n  font-weight: 600;\n  font-size: 1rem;\n  color: #1a1a1a;\n  margin-bottom: 0.25rem;\n}\n\n.holiday-date-info {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.holiday-date {\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.holiday-day {\n  color: #4a90e2;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.holiday-type-badge {\n  display: inline-block;\n  padding: 0.25rem 0.6rem;\n  background: #e8f4f8;\n  color: #2c7ba0;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  width: fit-content;\n  margin-top: 0.25rem;\n}\n\n.holidays-info-section {\n  margin-top: 2rem;\n}\n\n.info-card {\n  background: #f8f9fa;\n  border-radius: 12px;\n  padding: 1.5rem;\n  border-left: 4px solid #4a90e2;\n}\n\n.info-card h3 {\n  margin: 0 0 1rem 0;\n  color: #1a1a1a;\n  font-size: 1.1rem;\n}\n\n.info-card ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.info-card li {\n  padding: 0.5rem 0;\n  color: #555;\n  line-height: 1.6;\n}\n\n.info-card li strong {\n  color: #1a1a1a;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .holidays-container {\n    padding: 1rem;\n  }\n\n  .holidays-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .holidays-controls {\n    justify-content: flex-end;\n  }\n\n  .calendar-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .calendar-month {\n    padding: 1rem;\n  }\n\n  .calendar-month-header {\n    font-size: 1.1rem;\n  }\n\n  .calendar-day {\n    min-height: 32px;\n    max-height: 45px;\n    padding: 0.15rem;\n  }\n\n  .day-number {\n    font-size: 0.65rem;\n  }\n\n  .holiday-flag {\n    font-size: 1rem;\n  }\n\n  .holidays-title-section h1 {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
